import api from './api';

export const createUploadForm = (file: File, fieldName: string, folder: string, metadata: Record<string, string> = {}): FormData => {
  const body = new FormData();
  body.append('folder', folder);
  Object.entries(metadata).forEach(([key, value]) => body.append(key, value));
  body.append(fieldName, file);
  return body;
};

export const uploadFile = <T>(url: string, file: File, fieldName: string, folder: string) =>
  api.post<T>(url, createUploadForm(file, fieldName, folder), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export interface AwsUploadResult { url: string; key: string; folder: string; name: string; mimeType: string; size: number; }
export const uploadAwsFile = (file: File, folder: string, metadata: Record<string, string> = {}) =>
  api.post<{ success: boolean; data: AwsUploadResult & { entity?: unknown } }>('/uploads', createUploadForm(file, 'file', folder, metadata)).then(response => response.data.data);
